import React, { Component } from 'react'
import { connect } from 'react-redux'
import { create } from '../../actions/account'

@connect(null, {create})
export default class NoAccount extends Component {
  onSubmit = e => {
    this.props.create({})
  }

  render () {
    return <div className='new-account login-window'>
      <div className='branding-logo' />
      <h1>Start your very own Fridge today</h1>
      <button className='btn' onClick={this.onSubmit}>Create Account</button>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/help/NoAccount.js